/**
 * Gets the tag description for making backend requests
 *
 * @param tagDescription Tag name from raw description or url to be converted back into tag description value
 */
const getProductTagDescriptionInternalValue = (tagDescription) => {
  let displayValue = '';

  if (tagDescription) {
    displayValue = decodeURIComponent(tagDescription);

    // special case where a dash is rendered
    if (displayValue.match(/^\d/) && !displayValue.includes('and under')) {
      displayValue = displayValue
        .replace(/(\d)[- ]+(\d)/, '$1 | $2')
        .replace(/\+/, '+ ');
    }

    // replace multiple dashes with one space
    displayValue = displayValue.replace(/-+/g, ' ');

    // pipe character is a spacial explicit dash placeholder
    displayValue = displayValue.replace(/\|/g, '-');

    displayValue = displayValue.replace(/&/g, ' & ');
  }

  return displayValue;
};

/**
 * Gets the tag description to display
 *
 * @param tagDescription Tag name from raw description or url to be converted back into tag description display value
 */
const getProductTagDisplayValue = (tagDescription) => {
  let descriptionValue = getProductTagDescriptionInternalValue(tagDescription);

  if (
    descriptionValue.match(/^\d/) &&
    descriptionValue.toLowerCase().includes('and under')
  ) {
    descriptionValue = `$${descriptionValue}`;
  }

  return descriptionValue;
};

/**
 * Gets the tag description for use in a url
 *
 * @param tagDescription Tag name from raw description or url to be converted into url safe value
 */
const getProductTagUrlValue = (tagDescription) => {
  let tagUrlValue = '';

  if (tagDescription) {
    tagUrlValue = decodeURIComponent(tagDescription);

    // special case plus sign and space are compressed
    if (tagUrlValue.match(/^\d/) && !tagUrlValue.includes('and under')) {
      tagUrlValue = tagUrlValue.replace(/\+ /, '+');
    }

    // replace any remaining spaces
    tagUrlValue = tagUrlValue.replace(/\s/g, '-');

    // replace multiple dashes with one dash
    tagUrlValue = tagUrlValue.replace(/-+/g, '-');

    // replace any dollar signs
    tagUrlValue = tagUrlValue.replace(/\$/g, '');

    // consolidate -&- to &
    tagUrlValue = tagUrlValue.replace(/-&-/g, '&');

    tagUrlValue = encodeURIComponent(tagUrlValue).replace(/%2F/g, '/');
  }

  return tagUrlValue.toLowerCase();
};

export default {
  getProductTagDisplayValue,
  getProductTagDescriptionInternalValue,
  getProductTagUrlValue,
};
